import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
type ModalType = 'privacy' | 'terms' | null;
const privacyContent = {
  title: 'Política de Privacidad',
  sections: [{
    heading: '1. Información que Recopilamos',
    text: 'Al realizar una compra, recopilamos tu nombre, dirección de correo electrónico y datos de pago procesados de forma segura a través de nuestra plataforma de pago (Shopify/Stan Store). No almacenamos información de tarjetas de crédito en nuestros servidores.'
  }, {
    heading: '2. Uso de la Información',
    text: 'Utilizamos tu información exclusivamente para: procesar tu compra y enviar el producto digital, enviarte actualizaciones relacionadas con tu compra, y mejorar nuestros productos y servicios.'
  }, {
    heading: '3. Protección de Datos',
    text: 'Implementamos medidas de seguridad estándar de la industria para proteger tu información personal. Tus datos están encriptados durante la transmisión y almacenados de forma segura.'
  }, {
    heading: '4. Compartir Información',
    text: 'No vendemos, intercambiamos ni transferimos tu información personal a terceros, excepto proveedores de servicios necesarios para procesar tu pedido (procesadores de pago, servicios de email).'
  }, {
    heading: '5. Cookies',
    text: 'Nuestro sitio puede utilizar cookies para mejorar tu experiencia de navegación y analizar el tráfico del sitio. Puedes desactivar las cookies en la configuración de tu navegador.'
  }, {
    heading: '6. Tus Derechos',
    text: 'Tienes derecho a acceder, corregir o eliminar tu información personal. Para ejercer estos derechos, contáctanos por correo electrónico.'
  }, {
    heading: '7. Cambios a Esta Política',
    text: 'Nos reservamos el derecho de actualizar esta política en cualquier momento. Los cambios serán publicados en esta página con la fecha de actualización.'
  }]
};
const termsContent = {
  title: 'Términos y Condiciones',
  sections: [{
    heading: '1. Producto Digital',
    text: 'Panza Plana Posparto en 21 Días es un producto digital (eBook en formato PDF) que se entrega mediante descarga instantánea tras la confirmación del pago. El acceso es inmediato y de por vida.'
  }, {
    heading: '2. Uso Personal',
    text: 'El contenido adquirido es para uso personal exclusivamente. Queda prohibida la reproducción, distribución, reventa o compartir el material con terceros sin autorización expresa.'
  }, {
    heading: '3. Descargo Médico',
    text: 'Este producto es informativo y educativo. No sustituye el consejo médico profesional. Consulta a tu médico antes de comenzar cualquier programa de ejercicios, especialmente si tuviste cesárea, complicaciones durante el parto, o estás en período de lactancia. Espera al menos 6 meses post-parto antes de iniciar.'
  }, {
    heading: '4. Resultados',
    text: 'Los resultados pueden variar según cada persona. Los testimonios y cifras presentados son ejemplos reales pero no garantizan resultados idénticos. El cumplimiento del programa al 90%+ es necesario para obtener resultados óptimos.'
  }, {
    heading: '5. Política de Reembolso',
    text: 'Debido a la naturaleza digital del producto y su entrega instantánea, no se ofrecen reembolsos una vez completada la descarga. Si tienes problemas técnicos con la descarga, contáctanos y te ayudaremos.'
  }, {
    heading: '6. Propiedad Intelectual',
    text: 'Todo el contenido, incluyendo textos, imágenes, diseños y metodología "Core Latino Posparto", es propiedad exclusiva de Panza Plana Posparto y está protegido por leyes de derechos de autor.'
  }, {
    heading: '7. Modificaciones',
    text: 'Nos reservamos el derecho de modificar estos términos en cualquier momento. El uso continuado del producto implica la aceptación de los términos actualizados.'
  }]
};
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  const modalData = activeModal === 'privacy' ? privacyContent : activeModal === 'terms' ? termsContent : null;
  return <>
      <footer className="bg-[#0A4A50] text-gray-400 py-12 px-4 border-t border-[#0D5C63]" data-id="element-33">
        <div className="max-w-6xl mx-auto text-center" data-id="element-34">
          <p className="font-serif text-[#FFF8F0] text-xl mb-4" data-id="element-35">
            Panza Plana Posparto
          </p>
          <p className="text-sm mb-8" data-id="element-36">
            © {new Date().getFullYear()} Panza Plana Posparto. Todos los
            derechos reservados.
          </p>
          <div className="flex justify-center gap-6 text-xs" data-id="element-37">
            <button onClick={() => setActiveModal('terms')} className="hover:text-[#C9A84C] transition-colors cursor-pointer" data-id="element-38">
              Términos y Condiciones
            </button>
            <button onClick={() => setActiveModal('privacy')} className="hover:text-[#C9A84C] transition-colors cursor-pointer" data-id="element-39">
              Política de Privacidad
            </button>
          </div>
          <p className="mt-8 text-[10px] max-w-2xl mx-auto opacity-50" data-id="element-40">
            Descargo de responsabilidad: Los resultados pueden variar. Este
            producto no sustituye el consejo médico profesional. Consulte a su
            médico antes de comenzar cualquier programa de ejercicios,
            especialmente si tuvo una cesárea o complicaciones durante el parto.
          </p>
        </div>
      </footer>

      {/* Modal */}
      <AnimatePresence data-id="element-41">
        {activeModal && modalData && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm" onClick={() => setActiveModal(null)} data-id="element-42">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          duration: 0.3,
          ease: 'easeOut'
        }} className="bg-[#FFF8F0] rounded-2xl shadow-2xl max-w-2xl w-full max-h-[85vh] overflow-hidden" onClick={e => e.stopPropagation()} data-id="element-43">
              {/* Header */}
              <div className="flex items-center justify-between p-6 border-b border-[#0D5C63]/10 sticky top-0 bg-[#FFF8F0] z-10" data-id="element-44">
                <h3 className="text-2xl font-bold text-[#0D5C63] font-serif" data-id="element-45">
                  {modalData.title}
                </h3>
                <button onClick={() => setActiveModal(null)} className="p-2 rounded-full hover:bg-[#0D5C63]/10 transition-colors" aria-label="Cerrar" data-id="element-46">
                  <X className="w-5 h-5 text-[#0D5C63]" data-id="element-47" />
                </button>
              </div>

              {/* Content */}
              <div className="p-6 overflow-y-auto max-h-[calc(85vh-80px)]" data-id="element-48">
                <p className="text-xs text-gray-400 mb-6" data-id="element-49">
                  Última actualización:{' '}
                  {new Date().toLocaleDateString('es-US', {
                month: 'long',
                year: 'numeric'
              })}
                </p>
                <div className="space-y-6" data-id="element-50">
                  {modalData.sections.map((section, index) => <div key={index} data-id="element-51">
                      <h4 className="font-bold text-[#0D5C63] mb-2" data-id="element-52">
                        {section.heading}
                      </h4>
                      <p className="text-[#2D2D2D] text-sm leading-relaxed" data-id="element-53">
                        {section.text}
                      </p>
                    </div>)}
                </div>
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
}